import React from 'react';
import { View, Text } from 'react-native';
import { TextInput, Stepper } from '@atoms';
import { Spacing, Typography } from '@styles';
import { useTheme } from '@themeProvider';
import { useLanguage } from '@languageProvider';

export const AddDelivery = ({ value, setValue, showTitle }) => {
    const { useColor } = useTheme();
    const [ body, title ] = useColor(['body', 'title']);
    const { translate } = useLanguage();
    return (
        <View style={{ marginHorizontal: Spacing.M }}>
            { !!showTitle && <Text style={[Typography.TITLE, { color: title, textAlign: 'center', marginHorizontal: Spacing.XS}]}>{translate('deliveryModalTitle')}</Text>}
            <Text style={[Typography.BODY, { color: body, marginHorizontal: Spacing.XS, marginBottom: Spacing.M }]}>
                {translate('addDeliveryExplanation')}
            </Text>
            <TextInput
                label={translate('seating')}
                information={`${translate('eg')}: 17B`}
                {...{value, setValue}}/>
        </View>
    )
}

export const AddGlass = ({ value, setValue }) => {
    const { useColor } = useTheme();
    const [body, title, label] = useColor(['body', 'title', 'label']);
    const { translate } = useLanguage();
    return (
        <View style={{ marginHorizontal: Spacing.M }}>
            <Text style={[Typography.TITLE, { color: title, textAlign: 'center', marginHorizontal: Spacing.XS }]}>{translate('glassModalTitle')}</Text>
            <Text style={[Typography.BODY, { color: body, marginHorizontal: Spacing.XS, marginVertical: Spacing.M }]}>
                {translate('addGlassExplanation')}
            </Text>
            <Text style={[Typography.OVERLINE, [{ color: label, textAlign: 'center' }]]}>{translate('glasses')}</Text>
            <Stepper {...{ value, setValue, min: 0 }} />
        </View>
    )
}